<template>
    <footer class="bg-gray-200">
        <div class="container grid grid-cols-3 gap-6 pb-32 pt-16">
            <div>
                <h3 class="logo text-2xl font-bold text-gray-800">Gesture</h3>
            </div>
            <div class="text-center">
                <ul>
                    <li>Home</li>

                    <li>About</li>
                    <li>Contact</li>
                </ul>
            </div>
            <div class="text-right">
                <ul>
                    <li>Facebook</li>
                    <li>Twitter</li>
                    <li>Youtube</li>
                </ul>
            </div>
        </div>
    </footer>
</template>
